// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"DialogPastListItems_dialogContent__NI7Mp"};